import { Body3 } from "../Typography";
import { makeStyles, Box } from "@material-ui/core";

interface InfoBannerProps {
  message: string;
}

const useStylesInfoBanner = makeStyles((theme) => ({
  banner: {
    display: "flex",
    alignItems: "center",
    padding: "6px 8px",
    background: "#F1F0FA",
    gap: "16px",
    alignSelf: "stretch",
    borderRadius: "4px",
    marginTop: "8px",
  },
  message: {
    color: "#48505C",
    fontWeight: 400,
    fontFamily: "Figtree",
    fontSize: "13px",
    lineHeight: "15.6px",
    fontStyle: "normal",
  },
}));

const InfoBanner = ({ message }: InfoBannerProps) => {
  const classes = useStylesInfoBanner();

  return (
    <Box className={`${classes.banner}`}>
      <Body3 className={classes.message}>{message}</Body3>
    </Box>
  );
};
export default InfoBanner;
